<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>

              <el-col :span="12" class="item">
                <el-form-item label="老人姓名" required prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入老人姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="紧急联系人" required prop="urgencyContact">
                  <el-input v-model="addForm.urgencyContact" placeholder="请输入紧急联系人"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="紧急联系人手机" required prop="urgencyPhone">
                  <el-input v-model="addForm.urgencyPhone" placeholder="请输入紧急联系人手机"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="老人类别" required prop="elderlyClassCode">
                  <el-select v-model="addForm.elderlyClassCode" placeholder="请选择老人类别"
                             style="width:100%" clearable>
                    <el-option v-for="item in elderlyClassList"
                               :key="item.elderlyClassCode"
                               :label="item.name"
                               :value="item.elderlyClassCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="所属组织区域" required prop="zoneCode">
                  <el-cascader placeholder="请选择所属组织区域" v-model="addForm.zoneCode" :options="zoneValue"
                               :props="zoneProps" style="width:100%" clearable ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="老人手机号">
                  <el-input v-model="addForm.phone" minlength="11" placeholder="请输入老人手机号"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="老人身份证号">
                  <el-input v-model="addForm.idCard" placeholder="请输入老人身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="老人家庭地址">
                  <el-input v-model="addForm.homeAddress" placeholder="请输入老人家庭地址"></el-input>
                </el-form-item>
              </el-col>




            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name: '',
        urgencyContact:'',
        urgencyPhone:'',

        phone:'',
        idCard: '',
        homeAddress: '',

        elderlyClassCode:'',
        zoneCode:'',

      },

      elderlyClassList: [],

      zoneValue:[],
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },

      rules:{

        name:[
          { required: true, message: '请输入老人姓名', trigger: 'blur' },
        ],
        urgencyContact:[
          { required: true, message: '请输入紧急联系人', trigger: 'blur' },
        ],
        urgencyPhone:[
          { required: true, message: '请输入紧急联系人手机号', trigger: 'blur' },
        ],
        elderlyClassCode:[
          { required: true, message: '请选择老人类别', trigger: 'blur' },
        ],
        zoneCode:[
          { required: true, message: '请选择组织', trigger: 'blur' },
        ],

      },

    }
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();

      this.addForm.name = '';
      this.addForm.phone = '';
      this.addForm.urgencyPhone = '';
      this.addForm.urgencyContact = '';
      this.addForm.idCard = '';
      this.addForm.homeAddress = '';

      this.getZoneList();
      this.getElderlyClassList();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    getElderlyClassList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyClass/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.elderlyClassList = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getZoneList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {

          var data = JSON.stringify(response.data.data);
          //把空数组删除
          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      })
    },



    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/AddGov2",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    }


  }
}


</script>

